function useSearchName() {
  return (name) => {
    if (!name) return {};

    const [firstName, ...rest] = name.split(" ");
    const lastName = rest.join(" ");

    return { firstName: firstName.trim(), lastName: lastName.trim() };
  };
}

export default useSearchName;
